(function () {
  // Preserve the media restriction without blocking links, form fields, or text.
  const protectedMedia = (target) => {
    if (!(target instanceof Element)) return null;
    if (target.closest('a, button, input, textarea, select, [contenteditable]:not([contenteditable="false"])')) return null;
    return target.closest('img, video');
  };

  document.addEventListener('contextmenu', (event) => {
    if (protectedMedia(event.target)) event.preventDefault();
  });

  document.addEventListener('dragstart', (event) => {
    if (protectedMedia(event.target)) event.preventDefault();
  });
})();
